<template>
    <b-modal
        :title="title"
        hide-footer
        v-model="modal"
        centered
        :no-close-on-esc="preventAccidentalClose"
        :hide-header-close="preventAccidentalClose"
        :no-close-on-backdrop="preventAccidentalClose"
    >
        <call-manage />
    </b-modal>
</template>

<script>
import { mapState } from "vuex";

// import CallTerms from "@/components/always/call/CallTerms";
import CallManage from "@/components/always/call/CallManage";

export default {
    computed: {
        preventAccidentalClose() {
            return this.currentCall ? true : false;
        },
        // surface live call status (Ringing / Call in Progress / Completed)
        // in the modal header so the H3 inside CallDetails can go. falls back
        // to a generic title for the preview / empty state.
        title() {
            return this.currentCall?.status || this.$t("Video Call");
        },
        modal: {
            get() {
                return this.$store.state.interface.videoCallModalVisible;
            },
            set(value) {
                this.$store.commit("interface/setVideoCallModalVisible", value);
            },
        },
        ...mapState({
            onboardingUser: (state) => state.onboarding.user,
        }),
        ...mapState("call", ["currentCall"]),
    },
    components: {
        // CallTerms,
        CallManage,
    },
};
</script>